import { createRouter, createWebHistory } from 'vue-router';
import store from '../store/index.js';
import HomeView from '../views/HomeView.vue';
import DocsView from '../views/DocsView.vue';
import StaticView from '../views/StaticView.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/docs',
    name: 'docs-index',
    component: DocsView,
    props: {
      slug: '',
      pageType: 'docs',
    },
  },
  {
    path: '/docs/:slug(.*)',
    name: 'docs',
    component: DocsView,
    props: route => ({
      slug: route.params.slug,
      pageType: 'docs',
    }),
  },
  {
    path: '/features',
    name: 'features-index',
    component: DocsView,
    props: {
      slug: '',
      pageType: 'features',
    },
  },
  {
    path: '/features/:slug(.*)',
    name: 'features',
    component: DocsView,
    props: route => ({
      slug: route.params.slug,
      pageType: 'features',
    }),
  },
  {
    path: '/policies/:slug(.*)',
    name: 'policies',
    component: StaticView,
    props: route => ({
      slug: route.params.slug,
      pageType: 'static',
    }),
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' };
    }
    return { top: 0 };
  },
});

// Router guard: auto-redirect to first published page when hitting index routes
const flattenPublishedPaths = nodes => {
  const results = [];
  const dfs = list => {
    if (!Array.isArray(list)) return;
    list.forEach(n => {
      if (n.published) {
        results.push(n.path || n.slug);
      }
      if (n.children && n.children.length) {
        dfs(n.children);
      }
    });
  };
  dfs(nodes || []);
  return results;
};

router.beforeEach(async (to, from, next) => {
  // Only when landing on index without slug
  const isDocsIndex = to.name === 'docs-index';
  const isFeaturesIndex = to.name === 'features-index';
  if (!isDocsIndex && !isFeaturesIndex) return next();

  const pageType = isFeaturesIndex ? 'features' : 'docs';

  // Ensure tree is loaded for this pageType
  try {
    const existing = store.getters['docs/pagesTree'];
    if (!existing || existing.length === 0) {
      await store.dispatch('docs/fetchTree', pageType);
    }
  } catch (e) {
    // If tree fails, continue without redirect
    return next();
  }

  const tree = store.getters['docs/pagesTree'] || [];
  const candidates = flattenPublishedPaths(tree);
  if (candidates.length > 0) {
    const targetName = pageType === 'features' ? 'features' : 'docs';
    return next({ name: targetName, params: { slug: candidates[0] } });
  }

  // No candidates; proceed normally
  return next();
});

export default router;
